import { render, staticRenderFns } from "./FormsView.vue?vue&type=template&id=15ef415a&scoped=true"
import script from "./FormsView.vue?vue&type=script&lang=js"
export * from "./FormsView.vue?vue&type=script&lang=js"
import style0 from "./FormsView.vue?vue&type=style&index=0&id=15ef415a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef415a",
  null
  
)

export default component.exports